import { Component, OnInit, Output , EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormGroup , FormControl , Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Comment } from 'src/app/models/comment.model';
import { CourseService } from 'src/app/services/course.service';
import { formatDate } from '@angular/common'

@Component({
  selector: 'app-comment-box',
  templateUrl: './comment-box.component.html',
  styleUrls: ['./comment-box.component.css']
})
export class CommentBoxComponent implements OnInit {

  commentForm:FormGroup;

  showDialog:boolean = false

  commentId:string = ''

  isPosting:boolean = false;
  oldComments:Comment[] = [];
  lastComments:Comment[] = [];

  @Input() isPostingComment:boolean = false;
  @Input() comments:Comment[];
  @Output() onPostComment:EventEmitter<string> = new EventEmitter();

  constructor(
    private toastr:ToastrService,
    private courseService:CourseService
  ) { }


  ngOnInit(): void {
    this.initialForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isPosting = this.isPostingComment;
    this.comments.sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1));
    // console.log(this.comments);
    // if (this.comments.length > 3){  
    //   this.lastComments = this.comments.splice(0, 3);
    //   this.oldComments = this.comments.splice(-3);
    //   this.lastComments.sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1));
    //   this.oldComments.sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1));
    // }else{
    //   this.lastComments = this.comments;
    // }
  }
  

  initialForm(){
    this.commentForm = new FormGroup({
      comment: new FormControl('', [
        Validators.required
      ])
    });
  }

  get comment() { return this.commentForm.get('comment'); }

  onSubmit(){
    if (this.commentForm.valid){
      this.onPostComment.emit(this.comment.value);
      this.comment.setValue('')
    }else{
      this.toastr.error("Please enter comment");
    }
  }

  onShowReplyDialog(commentId){
    this.commentId = commentId
    this.showDialog = true
  }

  onDismissDialog(){
    this.showDialog = false
  }

  onReply(text){
    if(text === ''){
      this.toastr.error('Please enter text!')
      return
    }
    let now = formatDate(new Date(), 'MMM-dd-yyyy HH:mm:aa', 'en_US')
    let user = JSON.parse(localStorage.getItem('user'))
    const commentDesc = {
      date:now,
      text:text,
      displayName:user.displayName
    }
    this.showDialog = false
    console.log(commentDesc)
    this.courseService.addReplyComment(this.commentId,commentDesc).subscribe(result=>{
      console.log(result)
      if(result.result){
        this.toastr.success('Replied comment succefully.')
      }else{
        this.toastr.error('Failed to reply!')
      }
    })
  }

  
}
